<template>
    <modal
        name="schedule-edit-modal"
        :width="`100%`"
        :height="450"
        :min-width="500"
        :min-height="450"
        :pivotX="0.5"
        :pivotY="0.5"
        :delay="100"
        :clickToClose="false"
        @before-open="beforeOpen"
    >
      <vue-scroll>
        <div class="FloatMenu md_overlay md_overlay_0">
            <div class="modal modal_0">
                <div class="md_content">
                    <!-- 보기 or 수정 화면의 경우 -->
                    <h6 class="--blue70 pb20" :class="scheduleEditSection===1 || scheduleEditSection === 0 ? '' : 'hidden'">
                        {{ this.event.title }}
                    </h6>
                    <!-- 새로운 환자를 등록할 경우 -->
                    <h6 class="--blue70" :class="scheduleEditSection===2 ? '' : 'hidden'">
                        <ScheduleNameSelect :refinedPatientListProps="refinedPatientList" ref="nameSelect"/>
                    </h6>
                    <span class="md_close">
                        <img
                            src="/images/union.svg"
                            alt=""
                            @click="modalClose"
                        >
                    </span>
                    <ScheduleViewSection
                        v-if="scheduleEditSection === 0"
                        :class="scheduleEditSection === 0 ? '' : 'hidden'"
                        :eventProps="event"
                        ref="viewSection"
                    />
                    <ScheduleEditSection
                        v-else-if="scheduleEditSection === 1"
                        :class="scheduleEditSection === 1 ? '' : 'hidden'"
                        class="input_max"
                        :eventProps="event"
                        ref="editSection"
                    />
                    <ScheduleWriteSection
                        v-else
                        :class="scheduleEditSection === 2 ? '' : 'hidden'"
                        class="input_max"
                        :eventProps="event"
                        style="margin-bottom: 35px"
                        ref="writeSection"
                    />
                    <div class="schedule_bottom_btn">
                        <div class="flex_item" :class="scheduleEditSection===0? 'hidden' : ''">
                            <a class="btn blue btn_basics pointer no-drag"
                               @click="$modal.show('yes-or-no-modal', {questionType:'save', function: saveSchedule})">
                                {{ $t('status.save') }}
                            </a>
                            <a class="btn gray btn_basics pointer no-drag" @click="cancelEditSchedule()">
                                {{ $t('status.cancel') }}
                            </a>
                        </div>
                        <div class="flex_item"
                             :class="scheduleEditSection===1 || scheduleEditSection===2? 'hidden' : ''">
                            <a class="btn gray btn_basics btn_full pointer no-drag" @click="editSchedule()">
                                {{ $t('status.edit')}}
                            </a>
                            <a class="btn red btn_basics btn_full deleteBtn pointer no-drag"
                               @click="$modal.show('yes-or-no-modal', {questionType : 'delete', function : cancelSchedule})">
                                {{ $t('status.delete')}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </vue-scroll>
    </modal>
</template>

<script>
import ScheduleViewSection from './view/index'
import ScheduleEditSection from './edit/index'
import ScheduleWriteSection from './write/index'
import ScheduleNameSelect from './nameSelect/index'
import _API from '../../../../api';

export default {
  name: 'ScheduleEditModal',
  components: {
    ScheduleViewSection,
    ScheduleEditSection,
    ScheduleWriteSection,
    ScheduleNameSelect,
  },
  props: [],
  data() {
    return {
      event: '',
      refinedPatientList: [],
      scheduleEditSection: 0
    }
  },
  methods: {
    close(e) {
      if (e.keyCode === 27) {
        e.stopPropagation();
        this.modalClose();
      }
    },
    modalClose: function () {
      document.removeEventListener('keyup', this.close)

      this.scheduleEditSection = 0;
      this.event = '';
      this.refinedPatientList = [];
      this.$modal.hide('schedule-edit-modal');
    },
    beforeOpen(event) {
      document.addEventListener('keyup', this.close)

      if (event.params === 'write') {
        // 새로쓰기의 경우
        this.event = '';
        this.scheduleEditSection = 2;
        this.refinedPatientList = [];
        this.makeSelectBoxKeyRange();
      } else if (event.params.class === 'available') {
        // 의사가 설정한 가능한 스케쥴을 누른 경우
        this.event = event.params;
        this.scheduleEditSection = 2;
        this.makeSelectBoxKeyRange();
      } else {
        // 편집의 경우
        this.event = event.params;
        this.scheduleEditSection = 0;
      }
    },
    cancelEditSchedule() {
      if (this.scheduleEditSection === 2) {
        this.modalClose();
      } else {
        this.scheduleEditSection = 0;
      }
    },
    editSchedule() {
      // 현재 이전의 날짜는 반려하기
      const {date, startTime} = this.$refs.viewSection.getValue();
      const scheduleExpectStartDatetime = this.moment(this.moment(new Date(date)).format('YYYY-MM-DD') + ' ' + startTime + ":00").format('YYYY-MM-DDTHH:mm:SSZ');
      if (this.moment(scheduleExpectStartDatetime).isBefore(this.moment(), 'minute')) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.past_dates_cannot_be_modified'
        });
        return
      }

      this.scheduleEditSection = 1;
    },
    makeSelectBoxKeyRange() {
      const patientList = this.$store.state.patientList.filter(
          item => item.check === true
              && item.patientEmail !== localStorage.getItem('userEmail')
      );

      for (let i = 0; i < patientList.length; i++) {
        const item = {};
        item["no"] = i + 1;
        item["key"] = i + 1;
        item["title"] = patientList[i].patientInfo.patientInfoName;
        item["seqMedicalRelation"] = patientList[i].patientInfo.seqMedicalRelation;
        this.refinedPatientList.push(item);
      }
    },
    cancelSchedule() {
      // TODO: 다른 브라우저 혹은 PC는 ?? 로그아웃 되겠지.? 다른 탭은??
      if (this.$store.getters.getVideoCallOpen === true && this.$store.getters.getVideoCallSelectedSchedule.seqSchedule === this.event.seqSchedule) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.already_in_progress'
        });
        return;
      }

      // 대기 상태의 스케쥴인지 확인 scheduleStatus === 0 대기상태
      if (this.event.scheduleStatus !== 0) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.only_waiting_can_be_canceled'
        });
        return;
      }

      return new Promise((resolve, reject) => {
        _API.SCHEDULE.cancelNotStartedYetSchedule(this.event.seqSchedule)
            .then(({data}) => {
              if (data?.isSuccess) {
                this?.$modal?.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.delete_completed'
                });
              } else {
                this?.$modal?.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.unexpected_error'
                });
              }
              this?.modalClose();
              this?.$emit('getMySchedule');
              resolve();
            })
            .catch(e => {
              console.log(`[cancelNotStartedYetSchedule] ${e}`);
              reject();
            });
      });
    },
    saveSchedule() {
      if (this.event.seqSchedule && this.event.class !== 'available')
        this.updateScheduleBySeqSchedule();
      else
        this.insertScheduleBySeqMedicalRelation();
    },
    insertScheduleBySeqMedicalRelation() {
      // new write
      // 데이터 가져오고 빈칸 리턴
      const seqMedicalRelation = this.$refs.nameSelect.getValue();
      if (seqMedicalRelation === undefined) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'account.empty_field'
        });
        return
      } else if (seqMedicalRelation === null || seqMedicalRelation === 0) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.unexpected_error'
        });
        return
      }
      const {date, startTime, progressTime} = this.$refs.writeSection.getValue();
      if (date === "" || date === 'Invalid date' || startTime === undefined || progressTime === undefined) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'account.empty_field'
        });
        return
      }

      const scheduleExpectStartDatetime = this.moment(this.moment(date).format('YYYY-MM-DD') + ' ' + startTime + ":00").format('YYYY-MM-DDTHH:mm:SSZ');

      if (this.moment(scheduleExpectStartDatetime).isBefore(this.moment(), 'minute')) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.check_due_date'
        });
        return
      }

      // 데이터 가공하기
      const param = {
        seqMedicalRelation: seqMedicalRelation,
        expectStartDatetime: scheduleExpectStartDatetime,
        expectProgressTime: typeof progressTime === "object" ? progressTime.value : progressTime
      };

      return new Promise((resolve, reject) => {
        _API.SCHEDULE.insertScheduleBySeqMedicalRelation(param)
            .then(({data}) => {
              this.scheduleMessage(data.isSuccess, data.failedCode, resolve);
            })
            .catch(e => {
              console.log(`[insertScheduleBySeqMedicalRelation] ${e}`);
              reject();
            });
      });
    },
    updateScheduleBySeqSchedule() {
      // TODO: 다른 브라우저 혹은 PC는 ?? 로그아웃 되겠지.? 다른 탭은??
      if (this.$store.getters.getVideoCallOpen === true && this.$store.getters.getVideoCallSelectedSchedule.seqSchedule === this.event.seqSchedule) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.already_in_progress'
        });
        return;
      }

      // edit
      // 데이터 null check
      const {date, startTime, progressTime} = this.$refs.editSection.getValue();
      if (date === null || startTime === null || progressTime === null) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'account.empty_field'
        });
        return;
      }

      // 데이터 가공하기
      const scheduleExpectStartDatetime = this.moment(this.moment(date).format('YYYY-MM-DD') + ' ' + (typeof startTime === "object" ? startTime.value : startTime) + ":00").format('YYYY-MM-DDTHH:mm:SSZ');

      if (this.moment(scheduleExpectStartDatetime).isBefore(this.moment(), 'minute')) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.check_due_date'
        });
        return
      }

      const inputData = {
        seqSchedule: this.event.seqSchedule,
        newExpectStartDatetime: scheduleExpectStartDatetime,
        newExpectProgressTime: typeof progressTime === "object" ? progressTime.value : progressTime
      };
      return new Promise((resolve, reject) => {
        _API.SCHEDULE.updateScheduleBySeqSchedule(inputData)
            .then(({data}) => {
              this.scheduleMessage(data.isSuccess, data.failedCode, resolve);
            })
            .catch(e => {
              console.log(`[updateScheduleBySeqSchedule] ${e}`);
              reject();
            });
      });
    },
    scheduleMessage(isSuccess, failedCode, resolve) {
      if (isSuccess) {
        this.$emit('getMySchedule');
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.save_completed'
        });
      } else {
        if (failedCode === "SE0113"
            || failedCode === "SE0114"
            || failedCode === "SE0115"
            || failedCode === "SE0116"
            || failedCode === "SE0101"
            || failedCode === "SE0103"
            // || failedCode === "SE0132"
            // || failedCode === "SE0133"
            || failedCode === "SE0134"
        ) {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: `alert.scheduleError.${failedCode}`
          });
        } else {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'alert.unexpected_error'
          });
        }
      }

      this.modalClose();
      resolve();
    },
  },
}
</script>
<style lang="scss">
.v--modal-overlay[data-modal="schedule-edit-modal"] {
  .md_overlay {
    background: none;
  }

  .v--modal {
    box-shadow: none;
    overflow: visible;
  }

  .md_content {
    height: 380px !important;
    max-width: 500px;

    .popup_title {
      margin-bottom: 3px;
    }

    .table-container {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 55px 60px 50px;
      width: 400px;
      height: 220px;

      &.input_max {
        input {
          max-width: 278px;
        }
      }

      .item-title {
        flex: 1 1 1rem;
      }

      .vs__dropdown-menu {
        max-height: 230px;
        overflow: scroll;
      }
    }

    .schedule_bottom_btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .flex_item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        a {
          margin-right: 0.6rem;

          &:nth-last-child(1) {
            margin-right: 0;
            margin-left: .1rem;
          }
        }
      }
    }
  }
}
</style>


